 <div class="row">
  <!--Temporizador-->
  <div class="column time text-title-md-bold">
    <p>{{hours <10 ? '0' : ''}}{{hours}}:{{minutes <10 ? '0' : ''}}{{minutes}}:<span class="seconds">{{seconds <10 ? '0' : ''}}{{seconds}}</span></p>
  </div>
  <!--Estado de la consulta-->
  <div class="column status text-regular-12">
    <p>{{ isFinished ? 'CITA TERMINADA' : 'EN CITA ACTUAL' }}</p>
  </div>
  <!--Botón de finalizado-->
  <div class="column finish">
    <button (click)="onEmitFinishAppointment()" *ngIf="!isFinished">
      <!--icono-->
      <div class="record"></div>
      <p>FINALIZAR</p>
    </button>
    <button *ngIf="isFinished" class="btn-finished">
      <!--icono-->
      <i nz-icon nzType="caret-right" nzTheme="outline"></i>
      <p>FINALIZADA</p>
    </button>
  </div>
</div>
